function ConstructAgingPeriodAggregateSettingsHelper(inputPeriods) {
    let allPeriods = inputPeriods;

    if (!allPeriods.includes("TotalOutstanding")) {
        allPeriods.push("TotalOutstanding");
    }

    let aggregateSettingsArray = [];

    allPeriods.forEach((period) => {
        let setting = { aggregate: "sum", field: period };

        aggregateSettingsArray.push(setting);
    });

    return aggregateSettingsArray;
}

export {ConstructAgingPeriodAggregateSettingsHelper};